// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"GenericPopover-primaryButton-1toXv0","container":"GenericPopover-container-TfOlOY","open":"GenericPopover-open-1H9eCa","arrow":"GenericPopover-arrow-1ZXvCW"};